var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSpotlight = function SvgIcoSpotlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none",
    viewBox: "0 0 20 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V2Q0 1.176.588.588A1.93 1.93 0 0 1 2 0h16q.824 0 1.413.588Q20 1.175 20 2v14q0 .824-.587 1.413A1.93 1.93 0 0 1 18 18zm0-2h2v-2H2zm14 0h2v-2h-2zM2 12h2v-2H2zm14 0h2v-2h-2zM2 8h2V6H2zm14 0h2V6h-2zM2 4h2V2H2zm14 0h2V2h-2zM6 16h8V2H6z"
  })));
};
export default SvgIcoSpotlight;